export class PaymentMethods {
  constructor({ http }) {
    this.http = http;
  }

  async list({ idAddress, address1, postcode, city, country, ip, countryIsoCode, languageIsoCode }) {
    let url = `payment/methods?LanguageIsoCode=${languageIsoCode}`;

    if (idAddress) {
      url += `&IdAddress=${idAddress}`;
    }
    if (address1) {
      url += `&Address1=${address1}`;
    }
    if (postcode) {
      url += `&Postcode=${postcode}`;
    }
    if (city) {
      url += `&City=${city}`;
    }
    if (country) {
      url += `&Country=${country}`;
    }
    if (ip) {
      url += `&IP=${ip}`;
    }
    if (countryIsoCode) {
      url += `&CountryIsoCode=${countryIsoCode}`;
    }

    const response = await this.http.API_AUTH.get(url);

    if (response.status === 200) {
      const { data } = response;
      return data;
    } else {
      throw new Error(`Unexpected status code: ${response.status}`);
    }
  }
}
